import Property from "../models/Property";

const properties = [
    new Property({
        id: 1,
        name: "Charmant Bungalow",
        location: "Paris, France",
        price: 250000,
        description: "Un bungalow confortable au cœur de Paris.",
        image: "image1.jpg",
        address: "123 Rue de Paris",
        lat: 48.8566,
        lng: 2.3522,
        numBeds: 3,
        numBaths: 2,
        perimeter: 120,
        publicationDate: "2024-01-01",
        authorId: 101,
        isSponsored: false
    }),
    new Property({
        id: 2,
        name: "Appartement Moderne",
        location: "New York, USA",
        price: 450000,
        description: "Un appartement moderne au centre-ville de New York.",
        image: "image2.jpg",
        address: "456 Avenue de NY",
        lat: 40.7128,
        lng: -74.0060,
        numBeds: 2,
        numBaths: 1,
        perimeter: 80,
        publicationDate: "2024-02-01",
        authorId: 102,
        isSponsored: true
    }),
    new Property({
        id: 3,
        name: "Maison de Plage",
        location: "Sydney, Australie",
        price: 650000,
        description: "Une belle maison de plage avec des vues imprenables.",
        image: "image3.jpg",
        address: "789 Boulevard de Sydney",
        lat: -33.8688,
        lng: 151.2093,
        numBeds: 4,
        numBaths: 3,
        perimeter: 200,
        publicationDate: "2024-03-01",
        authorId: 103,
        isSponsored: false
    }),
    new Property({
        id: 4,
        name: "Cabane de Montagne",
        location: "Aspen, USA",
        price: 300000,
        description: "Une cabane rustique dans les montagnes d'Aspen.",
        image: "image4.jpg",
        address: "123 Rue Aspen",
        lat: 39.1911,
        lng: -106.8175,
        numBeds: 3,
        numBaths: 2,
        perimeter: 150,
        publicationDate: "2024-04-01",
        authorId: 104,
        isSponsored: true
    }),
    new Property({
        id: 5,
        name: "Loft Urbain",
        location: "Londres, Royaume-Uni",
        price: 400000,
        description: "Un loft élégant au centre de Londres.",
        image: "image5.jpg",
        address: "456 Rue de Londres",
        lat: 51.5074,
        lng: -0.1278,
        numBeds: 2,
        numBaths: 1,
        perimeter: 90,
        publicationDate: "2024-05-01",
        authorId: 105,
        isSponsored: false
    }),
    new Property({
        id: 6,
        name: "Villa de Campagne",
        location: "Toscane, Italie",
        price: 500000,
        description: "Une villa luxueuse dans la campagne toscane.",
        image: "image6.jpg",
        address: "789 Rue de Toscane",
        lat: 43.7711,
        lng: 11.2486,
        numBeds: 5,
        numBaths: 4,
        perimeter: 300,
        publicationDate: "2024-06-01",
        authorId: 106,
        isSponsored: true
    }),
    new Property({
        id: 7,
        name: "Maison Suburbaine",
        location: "Toronto, Canada",
        price: 350000,
        description: "Une maison familiale dans les banlieues de Toronto.",
        image: "image7.jpg",
        address: "123 Rue de Toronto",
        lat: 43.651070,
        lng: -79.347015,
        numBeds: 4,
        numBaths: 3,
        perimeter: 180,
        publicationDate: "2024-07-01",
        authorId: 107,
        isSponsored: false
    }),
    new Property({
        id: 8,
        name: "Suite Penthouse",
        location: "Dubaï, EAU",
        price: 750000,
        description: "Une suite penthouse luxueuse à Dubaï.",
        image: "image8.jpg",
        address: "456 Avenue de Dubaï",
        lat: 25.276987,
        lng: 55.296249,
        numBeds: 3,
        numBaths: 3,
        perimeter: 200,
        publicationDate: "2024-08-01",
        authorId: 108,
        isSponsored: true
    }),
    new Property({
        id: 9,
        name: "Manoir Historique",
        location: "Édimbourg, Écosse",
        price: 600000,
        description: "Un manoir historique à Édimbourg.",
        image: "image9.jpg",
        address: "789 Boulevard d'Édimbourg",
        lat: 55.9533,
        lng: -3.1883,
        numBeds: 6,
        numBaths: 5,
        perimeter: 400,
        publicationDate: "2024-09-01",
        authorId: 109,
        isSponsored: false
    }),
    new Property({
        id: 10,
        name: "Condo Moderne",
        location: "Tokyo, Japon",
        price: 500000,
        description: "Un condo moderne au cœur de Tokyo.",
        image: "image10.jpg",
        address: "123 Rue de Tokyo",
        lat: 35.6895,
        lng: 139.6917,
        numBeds: 2,
        numBaths: 2,
        perimeter: 100,
        publicationDate: "2024-10-01",
        authorId: 110,
        isSponsored: true
    })
];

export default properties;
